import { render, staticRenderFns } from "./VideoDetailBar.vue?vue&type=template&id=60815d78&scoped=true"
import script from "./VideoDetailBar.vue?vue&type=script&lang=ts"
export * from "./VideoDetailBar.vue?vue&type=script&lang=ts"
import style0 from "./VideoDetailBar.vue?vue&type=style&index=0&id=60815d78&prod&lang=stylus&scoped=true"
import style1 from "./VideoDetailBar.vue?vue&type=style&index=1&id=60815d78&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60815d78",
  null
  
)

export default component.exports